import { Add } from '@mui/icons-material';
import { Button, Grid, Typography } from '@mui/material';

const styles = {
    title: { fontWeight: 400 },
};

const ReviewRequestHeader = ({ onNewRequest }) => {
    return (
        <Grid container item justifyContent={'space-between'} alignItems={'center'}>
            <Grid item>
                <Typography variant="h4" sx={styles.title}>
                    Reviews
                </Typography>
            </Grid>
            <Grid item>
                <Button variant="contained" color="secondary" size="large" startIcon={<Add />} onClick={onNewRequest}>
                    NEW REVIEW REQUEST
                </Button>
            </Grid>
        </Grid>
    );
};

export default ReviewRequestHeader;
